import { useState } from "react";
import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";

const useFFmpeg = () => {
  const [progress, setProgress] = useState<{}>();
  const [videoBlob, setVideoBlob] = useState<Blob>();

  let ffmpeg = createFFmpeg({
    corePath: "https://unpkg.com/@ffmpeg/core@0.10.0/dist/ffmpeg-core.js",
    log: false,
    progress: value => setProgress(value) //
  });

  const load = async () => {
    if (!ffmpeg.isLoaded()) {
      await ffmpeg.load();
    } else {
      try {
        ffmpeg.exit();
      } catch (_) {
        ffmpeg = createFFmpeg({
          corePath: "https://unpkg.com/@ffmpeg/core@0.10.0/dist/ffmpeg-core.js",
          log: false,
          progress: value => setProgress(value)
        });
        await ffmpeg.load();
      }
    }
  };

  const transcode = async (file: File | Blob) => {
    await load();
    // Write the file to memory
    ffmpeg.FS("writeFile", "video.mp4", await fetchFile(file));

    // Run the FFMpeg command
    await ffmpeg.run("-i", "video.mp4", "-c", "copy", "-map", "0", "-movflags", "faststart", "output.mp4");

    // Read the result
    const output = ffmpeg.FS("readFile", "output.mp4");
    const blobOutput = new Blob([output instanceof Uint8Array ? output : new Uint8Array(output)], {
      type: "video/mp4"
    });

    setVideoBlob(blobOutput);

    return blobOutput;
  };

  return {
    progress,
    videoBlob,
    transcode
  };
};

export default useFFmpeg;
